import type { components } from '@pba/types-openapi-client';
import { parseISO } from 'date-fns';
import type { AgeGroup } from './age-group';

export type UserBase = {
  ageGroup: AgeGroup;
  createdAt: Date;
  email: string;
  firstName: string;
  fullName: string;
  id: string;
  lastName: string;
  middleName?: string;
  name: string;
  nodeUserId?: string;
};

export const createUserBase = (data: components['schemas']['UserBase']): UserBase => ({
  ageGroup: data.age_group,
  createdAt: parseISO(data.created_at),
  email: data.email,
  firstName: data.first_name,
  fullName: data.full_name,
  id: data.id,
  lastName: data.last_name,
  middleName: data.middle_name,
  name: data.name,
  nodeUserId: data.node_id,
});
